<template lang="pug">
q-dialog(
    :model-value="showDrugstoreFilters"
    position="bottom"
    transition-show="slide-up"
    transition-hide="slide-down"
    full-width)
    .full-width.bg-secondary.b-radius-0.q-py-md.drugstore-filters-mobile.relative-position
        .row.absolute-top-right.q-pt-sm.q-pr-sm
            q-btn(
                flat
                round
                fab-mini
                v-close-popup
                @click="$emit('hide')")
                q-icon(
                    name="etabl:cross"
                    size="xs"
                    color="grey-4")
        slot(name="filters")
</template>

<script>
import CityFormMobile from 'components/CityForm/CityFormMobile.vue';

export default {
    name: 'DrugstoreFiltersMobile',
    components: { CityFormMobile },
    props: {
        showDrugstoreFilters: {
            type: Boolean,
            default: () => false,
        },
    },
};
</script>

<style lang="scss" scoped>
.drugstore-filters-mobile {
    border-radius: $mobile-border-radius $mobile-border-radius 0 0 !important;
    box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.15);
    padding-bottom: calc(8px + constant(safe-area-inset-bottom));
    padding-bottom: calc(8px + env(safe-area-inset-bottom));
}
</style>
